import {SALPrinterActions} from "../actions/SALPrinterActions";
import {ResponseStatus} from "../../utils/ResponseStatus";
import {Endpoints} from "../../utils/network/Enpoints";
import {axiosGET} from "../../utils/network/NetworkUtils";
import {Constants, MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {AnalyticEventKeys} from "@amzn/dolphin-web-framework";
import {NativeMeshInteractor} from "@amzn/dolphin-web-framework";

export function getSALFormat(dispatcher, printerType) {
    dispatcher({type: SALPrinterActions.LOADING})
    const params = {
        params: {
            printerType: printerType
        }
    };
    getSALFormatForStation(dispatcher, params);
}


async function getSALFormatForStation(dispatcher, params) {
    let startTime = Date.now();
    try {
        const response = await axiosGET("getSALFormatForStation", Endpoints.GET_SAL_FORMAT, params);
        if (response.data.responseCode === ResponseStatus.SUCCESS) {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE,
                responseCode: response.data.responseCode,
                printerFormat: response.data.printerFormat
            });
            NativeMeshInteractor.setSalFormat(response.data.printerFormat, "InductSAL")
        }
        else {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR,
                responseCode: ResponseStatus.ERROR,
            });
        }
        MobileAnalyticsHelper.executeAPIAnalytics(AnalyticEventKeys.Modules.INDUCT_GET_SAL_FORMAT, startTime);
    } catch(error) {
        if (error.message === Constants.ErrorCode.DEVICE_OFFLINE) {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR,
                responseCode: ResponseStatus.NO_INTERNET,
            });
        }
        else {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR,
                responseCode: ResponseStatus.ERROR,
            });
        }
        MobileAnalyticsHelper.executeAPIAnalytics(AnalyticEventKeys.Modules.INDUCT_GET_SAL_FORMAT, startTime,true);
    }
}